import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

interface SubscriptionLoginPopupModalProps {
  open: boolean;
  onClose?: () => void;
}

const SubscriptionLoginPopupModal: React.FC<SubscriptionLoginPopupModalProps> = ({
  open,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>Subscription</DialogTitle>
      <DialogContent>
        Please create an account before subscribing. If you already have an
        account Please login.
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={() => navigate(`${process.env.PUBLIC_URL}/login`)}
        >
          Login
        </Button>
        <Button
          variant="text"
          onClick={() => navigate(`${process.env.PUBLIC_URL}/sign-up`)}
        >
          Sign Up
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionLoginPopupModal;
